<template>

  <v-jumbotron>
    <v-container fill-height>
      <v-layout align-center>
        <v-flex>
          <h4 class="display-2 my-3">
            Password reset.
          </h4>
          <span class="subheading">
            <p>Your password has been reset and you have been logged out.</p>
          </span>
          <span class="subheading">
            <p>Please check your email for the link to reset your password, and click the link. Then return here to login with the new password.</p>
            <v-btn to="login" class="mx-0" color="primary">Go to login</v-btn>
          </span>
        </v-flex>
      </v-layout>
    </v-container>
  </v-jumbotron>

</template>

<script>
  export default {
    name: 'ResetPasswordConfirmation',
    data () {
      return {
      }
    },
    mounted () {
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/User/ResetPasswordConfirmation.vue